import { createSlice } from '@reduxjs/toolkit';
import {
  login,
  logout,
  refreshAuthToken,
  initializeAuth,
  fetchCurrentUser,
} from '../actions/authThunks';

/**
 
 * This Redux slice manages loading states for authentication-related asynchronous actions.
 * It tracks the status of actions like login, logout, token refresh, and auth initialization,
 * providing a centralized and predictable way to handle global loading indicators.
 *
 * Actions Tracked:
 * - login: Tracks the login process.
 * - logout: Tracks the logout process.
 * - refreshAuthToken: Tracks token refresh operations.
 * - initializeAuth: Tracks the initialization of authentication state.
 */
const initialState = {
  login: false,
  logout: false,
  refreshToken: false,
  initializeAuth: false,
};

const loadingSlice = createSlice({
  name: 'loading',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Login
      .addCase(login.pending, (state) => {
        state.login = true;
      })
      .addCase(login.fulfilled, (state) => {
        state.login = false;
      })
      .addCase(login.rejected, (state) => {
        state.login = false;
      })
      // Logout
      .addCase(logout.pending, (state) => {
        state.logout = true;
      })
      .addCase(logout.fulfilled, (state) => {
        state.logout = false;
      })
      .addCase(logout.rejected, (state) => {
        state.logout = false;
      })
      // Refresh Token
      .addCase(refreshAuthToken.pending, (state) => {
        state.refreshToken = true;
      })
      .addCase(refreshAuthToken.fulfilled, (state) => {
        state.refreshToken = false;
      })
      .addCase(refreshAuthToken.rejected, (state) => {
        state.refreshToken = false;
      })
      // Initialize Auth
      .addCase(initializeAuth.pending, (state) => {
        state.initializeAuth = true;
      })
      .addCase(initializeAuth.fulfilled, (state) => {
        state.initializeAuth = false;
      })
      .addCase(initializeAuth.rejected, (state) => {
        state.initializeAuth = false;
      })
      // FetchCurrentUser
      .addCase(fetchCurrentUser.pending, (state) => {
        state.fetchCurrentUser = true;
      })
      .addCase(fetchCurrentUser.fulfilled, (state) => {
        state.fetchCurrentUser = false;
      })
      .addCase(fetchCurrentUser.rejected, (state) => {
        state.fetchCurrentUser = false;
      });
  },
});

export default loadingSlice.reducer;
